import { first, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfirmationDialogModel } from '@app/shared/confirmation-dialog/confirmation-dialog.component';
import { BaseService } from '@app/core/services/base.service';
import { DEFAULT_TOASTS } from '@app/core/services/api/toast.message';

const MSG = DEFAULT_TOASTS;

export type HttpClientGetParams<S> = Parameters<typeof HttpClient.prototype.get<S>>;

export class BaseApi extends BaseService {
  GET<S>(...params: HttpClientGetParams<S>): Observable<S> {
    const [url, options] = params;
    return this.handleHttp<S>(this.http.get<S>(this.buildPath(url), options)).pipe(first());
  }

  PATCH<S>(path: string = '', body: any = {}, confirmationDialogModel?: ConfirmationDialogModel, message = MSG.PATCH): Observable<S> {
    return this.handleHttp(this.http.patch<S>(this.buildPath(path), body), message, confirmationDialogModel).pipe(first());
  }

  PUT<S>(path: string = '', body: any = {}, confirmationDialogModel?: ConfirmationDialogModel, message = MSG.PUT) {
    return this.handleHttp(this.http.put<S>(this.buildPath(path), body), message, confirmationDialogModel).pipe(first());
  }

  POST<S>(path: string = '', body: any = {}, message = MSG.POST) {
    return this.handleHttp(this.http.post<S>(this.buildPath(path), body), message).pipe(first());
  }

  DELETE<S>(path: string = '', confirmationDialogModel?: ConfirmationDialogModel, message = MSG.DELETE) {
    return this.handleHttp(this.http.delete<S>(this.buildPath(path)), message, confirmationDialogModel).pipe(first());
  }
}
